import {delegate, service} from './caller'
import axios from "axios";

export default {delegate, service, axios};